module.exports = fox._r("images/contest-top-bg.jpg", __webpack_public_path__ + "images/contest-top-bg.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/contest-top-bg.jpg
// module id = 163
// module chunks = 5